import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPaginationUrl, getPages } from 'component/pagination/utils'

import {
  FETCH_HIGHER_ADJUSTMENTS_REQUEST,
  FETCH_HIGHER_ADJUSTMENTS_SUCCESS,
  FETCH_HIGHER_ADJUSTMENTS_ERROR,
} from 'actionTypes'

/*
 * REQUEST HIGHER_ADJUSTMENTS
 */
export const fetchHigherAdjustments = (token, filters) => (dispatch) => {
  dispatch(fetchHigherAdjustmentsRequest())

  return new Api(token, dispatch)
    .post(
      getPaginationUrl(
        API_URL.HIGHER_ADJUSTMENTS_FIND,
        filters.page,
        filters.size
      ),
      filters
    )
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(getPages(response.metadata))
      dispatch(fetchHigherAdjustmentsSuccess(response.data.resultList))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchHigherAdjustmentsError(error))
      dispatch(hideSpinner())
    })
}

export const fetchHigherAdjustmentsRequest = () => ({
  type: FETCH_HIGHER_ADJUSTMENTS_REQUEST,
})

export const fetchHigherAdjustmentsSuccess = (data) => ({
  type: FETCH_HIGHER_ADJUSTMENTS_SUCCESS,
  payload: data,
})

export const fetchHigherAdjustmentsError = (error) => ({
  type: FETCH_HIGHER_ADJUSTMENTS_ERROR,
  payload: error,
})
